import { Grid } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import React, { FunctionComponent } from 'react';
import { usePermissions } from 'hooks';
import { reduceResolution, wbp } from 'Theme';
import { useCommonStyles } from './CommonStyles';
import HeaderCell from './HeaderCell';

interface TableHeaderProps {
    className?: string;
    sort: {
        field: 'clientName' | 'lastVisit';
        direction: 'asc' | 'desc';
    };
    onSort: (field: 'clientName' | 'lastVisit') => void;
}

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        spinner: {
            [theme.breakpoints.down(wbp)]: {
                marginTop: `${reduceResolution(50)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                marginTop: '50px'
            }
        },
        header: {
            backgroundColor: '#FAFAFA',
            borderBottom: '2px solid black',

            [theme.breakpoints.down('sm')]: {
                display: 'none'
            },
            [theme.breakpoints.up('md')]: {
                paddingTop: '18px',
                paddingBottom: '18px'
            }
        }
    })
);

export const TableHeader: FunctionComponent<TableHeaderProps> = props => {
    const classes = useStyles();
    const commonClasses = useCommonStyles();
    const permissions = usePermissions();
    const canViewSensitiveContact = permissions.clients.viewSensitiveContact;
    const clientNameColumnSize = canViewSensitiveContact ? 3 : 5;

    return (
        <Grid
            container
            className={clsx(classes.header, commonClasses.rowContainer, props.className)}
        >
            <HeaderCell
                xs={clientNameColumnSize}
                title="Client Name"
                sortDirection={props.sort.field === 'clientName' ? props.sort.direction : undefined}
                onSort={() => props.onSort('clientName')}
            />
            <HeaderCell
                xs={1}
                title="# Pets"
                className={commonClasses.cellCenter}
            />
            {canViewSensitiveContact && (
                <HeaderCell
                    xs={2}
                    title="Phone"
                />
            )}
            <HeaderCell
                xs={1}
                title="Visits"
                className={commonClasses.cellCenter}
            />
            <HeaderCell
                xs={1}
                title="Last Visit"
                sortDirection={props.sort.field === 'lastVisit' ? props.sort.direction : undefined}
                onSort={() => props.onSort('lastVisit')}
            />
            <HeaderCell
                xs={2}
                title="Next Visit"
            />
            <HeaderCell xs={1} />
            <HeaderCell xs={1} />
        </Grid>
    );
};

export default TableHeader;
